import { FaBars } from "react-icons/fa";
import { Link as LinkRouter } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
  background: #000000;
  height: 80px;
  z-index: 1000;
  position: relative;
  top: 0;
  width: 100%;
  box-shadow:
    0 4px 20px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.1),
    0 0 20px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(15px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  animation: navbarGlow 3s ease-in-out infinite alternate;

  @keyframes navbarGlow {
    0% {
      box-shadow:
        0 4px 20px rgba(0, 0, 0, 0.3),
        0 0 0 1px rgba(255, 255, 255, 0.1),
        0 0 20px rgba(0, 0, 0, 0.2);
    }
    100% {
      box-shadow:
        0 4px 20px rgba(0, 0, 0, 0.3),
        0 0 0 1px rgba(255, 255, 255, 0.1),
        0 0 30px rgba(0, 0, 0, 0.3);
    }
  }
`;



export const Logo = styled(LinkRouter)`
  img {
    width: 47px;
    height: 47px;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.1);
  }
`;

export const Bars = styled(FaBars)`
  display: none;
  color: #ffffff;
  font-size: 1.8rem;
  cursor: pointer;
  transition: color 0.3s ease;
  @media screen and (max-width: 768px) {
    display: block;
    &:hover {
      color: #cccccc;
    }
  }
`;

export const MenuText = styled.div`
  cursor: pointer;
  padding: 16px 24px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 25px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translate(-50%, -50%) scale(1.05);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  }

  span {
    color: #ffffff;
    font-size: 1.4rem;
    font-weight: 500;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -24px;

  .menu-item + .menu-item {
    margin-left: 1rem;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 6px;
  

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
